import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { Users } from 'Services';
import { ConfirmationModal } from 'Components/Common/Modal';

// Images
import Logo from 'Assets/images/logo.png';
import IconText from 'Assets/images/icons/text.png';
import IconEmail from 'Assets/images/icons/email.png';
import IconEmailText from 'Assets/images/icons/email-text.png';

export default ({ userId, onHide, pageType, strategyId, ...props }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({ phone_number: '' });

  useEffect(() => {
    const getUserDetails = async () => {
      setIsLoading(true);
      try {
        setUserDetails(await Users.getProfileDetails(userId));
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    getUserDetails();
  }, [userId]);

  const formatUsPhone = (phoneNumber) => {
    return phoneNumber
      .toString()
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  };

  const handleContactClick = async (option) => {
    try {
      const result = await ConfirmationModal('Are you sure?');
      if (result.isConfirmed) {
        onHide();
        if (pageType !== 'portfolio') history.push(`/strategy/${strategyId}/payment?type=signal-notification&notification-option=${option}`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal {...props} size="md" centered className="signal-notifications-modal" onHide={onHide} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <img src={Logo} alt="logo" className="logo" />
        {isLoading ? (
          <div>
            <Spinner animation="border" size="lg" className="mt-5" />
          </div>
        ) : (
          <>
            <p className="sub-title mt-3 mb-0">What is your preferred method</p>
            <span className="sub-title">for receiving notifications?</span>

            <div className="box-wrapper mt-4" role="button" tabIndex={0} onClick={() => handleContactClick('PHONE')}>
              <img src={IconText} alt="icon" />
              <span className="name">Text: {formatUsPhone(userDetails?.phone_number)}</span>
            </div>
            <div className="box-wrapper" role="button" tabIndex={0} onClick={() => handleContactClick('EMAIL')}>
              <img src={IconEmail} alt="icon" />
              <span className="name">Email: {userDetails?.email}</span>
            </div>
            <div className="box-wrapper" role="button" tabIndex={0} onClick={() => handleContactClick('BOTH')}>
              <img src={IconEmailText} alt="icon" />
              <span className="name">Both (Text & Email)</span>
            </div>
            <Button className="mt-2">Add another contact method</Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
